module.exports = __webpack_public_path__ + "02_glasses_black.9a56e318.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/02_glasses_black.png
// module id = +rlf
// module chunks = 0